<template>
  <section>
    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>

    <!--列表-->
    <el-table
      :data="prodOutMaster"
      highlight-current-row
      @current-change="selectCurrentRow"
      v-loading="listLoading"
      @selection-change="selsChange"
      style="width: 100%"
    >
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column prop="Code" label="编号" width="150"></el-table-column>
      <el-table-column prop="ClientName" label="出货单号" width="190">
        <template slot-scope="scope">
          <div>{{ scope.row.Code }}</div>
          <div>{{ scope.row.ProductionTime }}</div>
          <div>{{ scope.row.StationLineName }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="TaskCode" label="工程信息">
        <template slot-scope="scope">
          <div>{{ scope.row.ProjectName }}</div>
          <div>
            施工部位：
            <span class="table-value">{{ scope.row.ProjectPart }}</span>
            浇筑方式：
            <span class="table-value">{{ scope.row.PouringMethodName }}</span>
          </div>
          <div>
            强度等级：
            <span class="table-value">{{ scope.row.GradeName }}</span>
            特殊材料：
            <span class="table-value">{{ scope.row.SpecMtlName }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="ProjectName" label="方量信息">
        <template slot-scope="scope">
          <div>
            发货：
            <span class="table-value">{{ scope.row.QuantityDelivery }}</span>
            签收：
            <span class="table-value">{{ scope.row.SigningQuantity }}</span>
          </div>
          <div>
            混凝土：
            <span class="table-value">{{ scope.row.TQuantity }}</span>
            砂浆：
            <span class="table-value">{{ scope.row.SQuantity }}</span>
          </div>
          <div>
            累计方量：
            <span class="table-value">{{ scope.row.QuantityTotal }}</span>
            单价：
            <span class="table-value">{{ scope.row.Price }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="Remark" label="车辆信息">
        <template slot-scope="scope">
          <div>
            车号司机：
            <span class="table-value">
              {{ scope.row.VehicleErpCode }} {{ scope.row.DriverName }}
            </span>
          </div>
          <div>
            累计车次：
            <span class="table-value">{{ scope.row.VehiclesTotal }}</span>
          </div>
          <div>
            任务单号：
            <span class="table-value">{{ scope.row.TaskCode }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-link
            v-if="canEdit"
            type="primary"
            @click="
              () => {
                currentRow = scope.row;
                handleEdit();
              }
            "
          >
            编辑
          </el-link>
          <el-link
            v-if="canDelete"
            type="danger"
            @click="
              () => {
                sels.push(scope.row);
                handleDel();
              }
            "
          >
            删除
          </el-link>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      layout="total, sizes, prev, pager, next, jumper"
      :page-size="pageSize"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
      class="my-pagination"
    ></el-pagination>
    <!-- 签收 -->
    <el-dialog
      title="签收"
      :visible.sync="singeFormVisible"
      v-model="singeFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="singeForm"
        label-width="120px"
        :rules="singeFormRules"
        ref="singeForm"
      >
        <el-form-item label="出货单号">
          <el-input v-model="singeForm.Code"></el-input>
        </el-form-item>
        <el-form-item label="客户名称">
          <el-input v-model="singeForm.ClientName"></el-input>
        </el-form-item>
        <el-form-item label="工程名称">
          <el-input v-model="singeForm.ProjectName"></el-input>
        </el-form-item>
        <el-form-item label="强度等级">
          <el-input v-model="singeForm.GradeName"></el-input>
        </el-form-item>
        <el-form-item label="混凝土方量">
          <el-input v-model="singeForm.TQuantity"></el-input>
        </el-form-item>
        <el-form-item label="砂浆方量">
          <el-input v-model="singeForm.SQuantity"></el-input>
        </el-form-item>
        <el-form-item label="签收方量">
          <el-input v-model="singeQuantity"></el-input>
        </el-form-item>
        <el-form-item label="发货方量">
          <el-input v-model="singeForm.QuantityDelivery"></el-input>
        </el-form-item>
        <el-form-item label="签收方量">
          <el-input v-model="singeForm.SigningQuantity"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="singeForm.Remark"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="singeFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="singeSubmit"
          :loading="addLoading"
        >
          提交
        </el-button>
      </div>
    </el-dialog>
    <!--新增编辑界面-->
    <el-dialog
      :title="isEdit ? '修改' : '新增'"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="addForm"
        label-width="120px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="生产时间">
              <el-date-picker
                v-model="addForm.ProductionTime"
                type="datetime"
                placeholder="选择日期时间"
                value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="回站时间">
              <el-date-picker
                v-model="addForm.BackTime"
                type="datetime"
                placeholder="选择日期时间"
                value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="生产线">
              <el-select
                v-model="addForm.StationLineID"
                placeholder="请选择"
                @change="selectStation"
              >
                <el-option
                  v-for="item in stationLine"
                  :key="item.Id"
                  :label="item.Name"
                  v-model="item.Id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="搅拌站">
              <template>
                <el-select
                  v-model="addForm.OrgID"
                  filterable
                  placeholder="请选择"
                  @change="selectOrg"
                >
                  <el-option
                    v-for="item in orgList"
                    :key="item.Id"
                    :label="item.Name"
                    v-model="item.Id"
                  ></el-option>
                </el-select>
              </template>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="任务选择" prop="ProjectName">
          <el-input v-model="addForm.TaskCode" readonly class="input-select" />
          <el-button
            type="primary"
            @click="visibleDialog = true"
            :loading="listLoading"
          >
            选择
          </el-button>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="客户名称">
              <el-input v-model="addForm.ClientName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工程名称">
              <el-input v-model="addForm.ProjectName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="施工部位">
              <el-input v-model="addForm.ProjectPart"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="施工单位">
              <el-input v-model="addForm.ProjectCmpy"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="施工地址">
              <el-input v-model="addForm.ProejctAddress"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="票据类别" prop="BillType">
              <el-select v-model="addForm.BillType" placeholder="请选择类别">
                <el-option label="送料" :value="0"></el-option>
                <el-option label="砂浆" :value="100"></el-option>
                <el-option label="拉水" :value="200"></el-option>
                <el-option label="补方" :value="300"></el-option>
                <el-option label="其他" :value="400"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="打印抬头">
          <el-input v-model="addForm.PrintTitle"></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="8">
            <el-form-item label="发货方量">
              <el-input v-model="addForm.QuantityDelivery"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="混凝土方量">
              <el-input v-model="addForm.TQuantity"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="砂浆方量">
              <el-input v-model="addForm.SQuantity"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="特殊材料">
          <el-checkbox-group v-model="specMtlIDList">
            <el-checkbox
              v-for="item in baseData.SpecialMaterialList"
              :label="item.Id"
              :key="item.Id"
              @change="changeSpecialMaterial(item, $event)"
            >
              {{ item.Name }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-row>
          <el-col :span="8">
            <el-form-item label="强度等级">
              <template>
                <el-select
                  v-model="addForm.GradeID"
                  filterable
                  placeholder="请选择"
                  @change="selectGrade"
                >
                  <el-option
                    v-for="item in baseData.GradeList"
                    :key="item.Id"
                    :label="item.Name"
                    v-model="item.Id"
                  ></el-option>
                </el-select>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="浇筑方式">
              <template>
                <el-select
                  v-model="addForm.PouringMethodID"
                  filterable
                  placeholder="请选择"
                  @change="selectPouringMethod"
                >
                  <el-option
                    v-for="item in baseData.PouringMethodList"
                    :key="item.Id"
                    :label="item.Name"
                    v-model="item.Id"
                  ></el-option>
                </el-select>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="塌落度">
              <template>
                <el-select
                  v-model="addForm.TLD"
                  filterable
                  placeholder="请选择"
                  @change="selectTld"
                >
                  <el-option
                    v-for="item in baseData.TldList"
                    :key="item.Id"
                    :label="item.Name"
                    v-model="item.Id"
                  ></el-option>
                </el-select>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="备注">
          <el-input v-model="addForm.Remark"></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="联系人">
              <el-input v-model="addForm.ContactsName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话">
              <el-input v-model="addForm.ContactsPhone"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="运输距离">
          <el-input v-model="addForm.Distance"></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="8">
            <el-form-item label="司机选择" prop="DriverName">
              <el-input
                v-model="addForm.DriverName"
                readonly
                class="hr-select"
              />
              <el-button
                type="primary"
                @click="hrvisibleDialog = true"
                :loading="listLoading"
              >
                选择
              </el-button>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="车辆选择" prop="VehicleErpCode">
              <el-input
                v-model="addForm.VehicleErpCode"
                readonly
                class="hr-select"
              />
              <el-button
                type="primary"
                @click="vevisibleDialog = true"
                :loading="listLoading"
              >
                选择
              </el-button>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="操作员选择" prop="OperatorName">
              <el-input
                v-model="addForm.OperatorName"
                readonly
                class="hr-select"
              />
              <el-button
                type="primary"
                @click="opvisibleDialog = true"
                :loading="listLoading"
              >
                选择
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
        >
          提交
        </el-button>
      </div>
    </el-dialog>

    <TableDataDialog
      title="任务选择"
      :visibleDialog="visibleDialog"
      :queryMethod="queryData"
      :columns="{
        Title: {
          label: '任务名称',
        },
        ClientName: {
          label: '客户名称',
        },
        ProjectName: {
          label: '工程名称',
        },

        ProjectPart: {
          label: '施工部位',
        },
        Remark: {
          label: '备注',
        },
        CreateTime: {
          label: '创建时间',
          filter: (item) => {
            return formatDate(item.CreateTime);
          },
        },
        CreateUser: {
          label: '创建人',
        },
      }"
      @getDialogVisible="setVisible"
      @callback="dialogCallback"
    ></TableDataDialog>

    <TableDataDialog
      title="司机选择"
      :visibleDialog="hrvisibleDialog"
      :queryMethod="hrqueryData"
      :columns="{
        Name: {
          label: '姓名',
        },
        Code: {
          label: '工号',
        },
        Remark: {
          label: '备注',
        },
        WorkStatus: {
          label: '在职状态',
          filter: (item) => {
            return item.WorkStatus == 0
              ? '实习'
              : item.WorkStatus == 1
              ? '试用'
              : item.WorkStatus == 2
              ? '正式'
              : item.WorkStatus == 3
              ? '临时'
              : item.WorkStatus == 4
              ? '离职'
              : '退休';
          },
        },
        CreateTime: {
          label: '创建时间',
          filter: (item) => {
            return formatDate(item.CreateTime);
          },
        },
        CreateUser: {
          label: '创建时间',
        },
      }"
      @getDialogVisible="hrsetVisible"
      @callback="hrdialogCallback"
    ></TableDataDialog>

    <TableDataDialog
      title="操作员选择"
      :visibleDialog="opvisibleDialog"
      :queryMethod="opqueryData"
      :columns="{
        Name: {
          label: '姓名',
        },
        Code: {
          label: '工号',
        },
        Remark: {
          label: '备注',
        },
        WorkStatus: {
          label: '在职状态',
          filter: (item) => {
            return item.WorkStatus == 0
              ? '实习'
              : item.WorkStatus == 1
              ? '试用'
              : item.WorkStatus == 2
              ? '正式'
              : item.WorkStatus == 3
              ? '临时'
              : item.WorkStatus == 4
              ? '离职'
              : '退休';
          },
        },
        CreateTime: {
          label: '创建时间',
          filter: (item) => {
            return formatDate(item.CreateTime);
          },
        },
        CreateUser: {
          label: '创建时间',
        },
      }"
      @getDialogVisible="opsetVisible"
      @callback="opdialogCallback"
    ></TableDataDialog>

    <TableDataDialog
      title="车辆选择"
      :visibleDialog="vevisibleDialog"
      :queryMethod="vequeryData"
      :columns="{
        Name: {
          label: '设备名称',
        },
        ErpCode: {
          label: '自编号',
        },
        License: {
          label: '车牌号',
        },
        Code: {
          label: '编号',
        },
        CarStatus: {
          label: '设备状态',
          filter: (item) => {
            return item.CarStatus == 0
              ? '待排'
              : item.CarStatus == 100
              ? '停用'
              : item.CarStatus == 200
              ? '维修'
              : item.CarStatus == 300
              ? '排队接料中'
              : item.CarStatus == 400
              ? '运输途中'
              : '未定义';
          },
        },
        CarType: {
          label: '车辆类型',
          filter: (item) => {
            return item.CarType == 0 ? '搅拌车' : item.CarType == 100 ? '泵车' : '其他类型';
          },
        },
        CreateTime: {
          label: '创建时间',
          filter: (item) => {
            return formatDate(item.CreateTime);
          },
        },
        CreateUser: {
          label: '创建时间',
        },
      }"
      @getDialogVisible="vesetVisible"
      @callback="vedialogCallback"
    ></TableDataDialog>
  </section>
</template>

<script>
//引入ProdOutMaster.js的所有export的对象,并起别名为api,通过api.***访问成员
import * as api from "../../api/prodoutmaster";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import TableDataDialog from "../../components/TableDataDialog";
import { getProdTaskListPage } from "../../api/prodTask";
import { getSysStationLineListPage } from "../../api/recipe";
import { getHrEmployeeListPage } from "../../api/hrEmployee";
import { getVehicleListPage } from "../../api/vehicle";
import { JsonHubProtocol } from "@aspnet/signalr";
export default {
  components: { Toolbar, TableDataDialog },
  data() {
    return {
      buttonList: [],
      currentRow: null,
      filters: {
        name: "",
      },
      prodOutMaster: [],
      baseData: [], //任务单基础数据
      specMtlIDList: [],
      specMtlName: [],
      specMtlID: [],
      orgList: JSON.parse(localStorage.sysOrgs),
      stationLine: [],
      total: 0,
      page: 1,
      pageSize: 20,
      listLoading: false,
      sels: [], //列表选中列
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        //Name: [{ required: true, message: "请输入物资名称", trigger: "blur" }],
      },
      singeFormRules: {
        //Name: [{ required: true, message: "请输入物资名称", trigger: "blur" }],
      },
      //新增编辑数据
      addForm: {},
      visibleDialog: false, //任务单列表选择
      hrvisibleDialog: false, //司机列表选择
      opvisibleDialog: false, //操作员列表选择
      vevisibleDialog: false, //车辆列表选择
      isEdit: false, //是否为编辑 true为编辑 默认新增
      singeFormVisible: false,
      singeForm: {},
      singeQuantity: 0,
    };
  },
  computed: {
    //计算属性,判断是否有权编辑
    canEdit() {
      let index = this.buttonList.findIndex(
        (s) => s.name === "编辑" || s.name === "修改"
      );
      return index > -1;
    },
    //计算属性,判断是否有权删除
    canDelete() {
      let index = this.buttonList.findIndex((s) => s.name === "删除");
      return index > -1;
    }
  },
  methods: {
    //单击表格行事件绑定方法
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    //工具条绑定事件方法
    callFunction(item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    //翻页事件绑定方法
    handleCurrentChange(val) {
      this.page = val;
      this.getProdOutMaster();
    },
    //获取物资
    getProdOutMaster() {
      let para = {
        page: this.page,
        key: this.filters.name,
        intPageSize: this.pageSize,
      };
      this.listLoading = true;
      api.getProdOutMasterListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.prodOutMaster = res.data.response.data;
        this.listLoading = false;
        this.currentRow = null;
        this.sels = [];
      });
    },
    getBaseData() {
      api.getGetProdOutMasterBaseData().then((res) => {
        this.baseData = res.data.response;
      });
    },
    //获取生产线列表
    getSysStationLineList(orgId) {
      let para = {
        key: orgId,
      };
      this.listLoading = true;
      getSysStationLineListPage(para)
        .then((res) => {
          this.stationLine = res.data.response.data;
          if (res.data.response.data.length > 0) {
            this.addForm.StationLineID = this.stationLine[0].Id;
            this.addForm.StationLineName = this.stationLine[0].Name;
          } else {
            this.addForm.StationLineID = null;
            this.addForm.StationLineName = null;
          }
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    //执行删除
    handleDel() {
      if (!this.sels || this.sels.length <= 0) {
        this.$message({
          message: "请勾选要删除的数据",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除选中的记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;

          let para = this.sels.map((item) => item.Id);

          api.batchDeleteProdOutMaster(para).then((res) => {
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getProdOutMaster();
          });
        })
        .catch(() => {})
        .finally(() => {
          this.listLoading = false;
        });
    },
    //显示签收界面
    handlSigning() {
      this.singeFormVisible = true;
      let row = this.currentRow;
      this.specMtlID = row.SpecMtlID.split(",");
      this.specMtlName = row.SpecMtlName.split(",");
      this.specMtlIDList = this.specMtlID;
      this.singeForm = row;
      this.singeQuantity = row.SigningQuantity;
    },
    //执行签收
    singeSubmit() {
      this.$refs.singeForm.validate((valid) => {
        if (valid) {
          this.addLoading = true;
          let para = Object.assign({}, this.singeForm);
          let user = JSON.parse(window.localStorage.user);

          if (user && user.uID > 0) {
          } else {
            this.$message({
              message: "登录信息已过期,请重新登录",
              type: "error",
            });
            this.$router.replace(
              this.$route.query.redirect ? this.$route.query.redirect : "/"
            );
          }
          api
            .singeProdOutMaster(para)
            .then((res) => {
              if (res && res.data && res.data.success) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["singeForm"].resetFields();
                this.singeFormVisible = false;
                this.getProdOutMaster();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            })
            .finally(() => {
              this.addLoading = false;
            });
        }
      });
    },
    //显示编辑界面
    handleEdit() {
      this.isEdit = true;
      this.addFormVisible = true;
      let row = this.currentRow;
      this.specMtlID = row.SpecMtlID.split(",");
      this.specMtlName = row.SpecMtlName.split(",");
      this.specMtlIDList = this.specMtlID;
      this.addForm = row;
    },
    //显示新增界面
    handleAdd() {
      this.isEdit = false;
      this.addFormVisible = true;
      this.addForm = {
        OrgID: JSON.parse(localStorage.currentOrg).Id,
        OrgCode: JSON.parse(localStorage.currentOrg).OrgCode,
        OrgName: JSON.parse(localStorage.currentOrg).Name,
      };
    },
    //执行新增/编辑
    addSubmit() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.addLoading = true;
          let para = Object.assign({}, this.addForm);
          let user = JSON.parse(window.localStorage.user);

          if (user && user.uID > 0) {
          } else {
            this.$message({
              message: "登录信息已过期,请重新登录",
              type: "error",
            });
            this.$router.replace(
              this.$route.query.redirect ? this.$route.query.redirect : "/"
            );
          }
          if (this.isEdit) {
            api
              .editProdOutMaster(para)
              .then((res) => {
                if (res && res.data && res.data.success) {
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["addForm"].resetFields();
                  this.addFormVisible = false;
                  this.getProdOutMaster();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              })
              .finally(() => {
                this.addLoading = false;
              });
          } else {
            api
              .addProdOutMaster(para)
              .then((res) => {
                if (res && res.data && res.data.success) {
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["addForm"].resetFields();
                  this.addFormVisible = false;
                  this.getProdOutMaster();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              })
              .finally(() => {
                this.addLoading = false;
              });
          }
        }
      });
    },
    //勾选表格数据事件绑定方法
    selsChange(sels) {
      this.sels = sels;
    },
    //切换分页大小绑定方法
    handleSizeChange(size) {
      this.pageSize = size;
      this.getProdOutMaster();
    },
    dialogCallback(data) {
      if (data.length > 0) {
        this.addForm.TaskID = data[0].Id;
        this.addForm.TaskCode = data[0].Code;
        this.addForm.ProjectID = data[0].ProjectID;
        this.addForm.ProjectName = data[0].ProjectName;
        this.addForm.ClientID = data[0].ClientID;
        this.addForm.ClientName = data[0].ClientName;
        this.addForm.ProjectPart = data[0].ProjectPart;
      }
      this.visibleDialog = false;
    },
    queryData(params) {
      return getProdTaskListPage(params);
    },
    setVisible(val) {
      this.visibleDialog = val;
    },

    hrdialogCallback(data) {
      if (data.length > 0) {
        this.addForm.DriverID = data[0].Id;
        this.addForm.DriverName = data[0].Name;
      }
      this.hrvisibleDialog = false;
    },
    hrqueryData(params) {
      return getHrEmployeeListPage(params);
    },
    hrsetVisible(val) {
      this.hrvisibleDialog = val;
    },
    opdialogCallback(data) {
      if (data.length > 0) {
        this.addForm.OperatorID = data[0].Id;
        this.addForm.OperatorName = data[0].Name;
      }
      this.opvisibleDialog = false;
    },
    opqueryData(params) {
      return getHrEmployeeListPage(params);
    },
    opsetVisible(val) {
      this.opvisibleDialog = val;
    },
    vedialogCallback(data) {
      if (data.length > 0) {
        this.addForm.VehicleID = data[0].Id;
        this.addForm.VehicleErpCode = data[0].ErpCode;
      }
      this.vevisibleDialog = false;
    },
    vequeryData(params) {
      return getVehicleListPage(params);
    },
    vesetVisible(val) {
      this.vevisibleDialog = val;
    },
    //强度等级改变时触发
    selectGrade(id) {
      var value = this.baseData.GradeList.filter((e) => e.Id == id)[0];
      this.addForm.GradeID = value.Id;
      this.addForm.GradeName = value.Name;
    },
    //组织机构改变时触发
    selectOrg(id) {
      this.addForm.OrgCode = this.orgList.filter((e) => e.Id == id)[0].OrgCode;
      this.addForm.OrgName = this.orgList.filter((e) => e.Id == id)[0].Nmae;
      this.addForm.OrgID = id;
      this.getSysStationLineList(id);
    },
    //塌落度改变时触发
    selectTld(id) {
      var value = this.baseData.TldList.filter((e) => e.Id == id)[0];
      this.addForm.TLD = value.Name;
      this.addForm.TLDID = value.Name;
    },
    //浇筑方式改变时触发
    selectPouringMethod(id) {
      var value = this.baseData.PouringMethodList.filter((e) => e.Id == id)[0];
      this.addForm.PouringMethodID = value.Id;
      this.addForm.PouringMethodName = value.Name;
    },
    //特殊材料选择
    changeSpecialMaterial(value, isTrue) {
      if (isTrue) {
        this.specMtlID.push(value.Id);
        this.specMtlName.push(value.Name);
      } else {
        this.specMtlID.splice(
          this.specMtlID.findIndex((x) => x === value.Id),
          1
        );
        this.specMtlName.splice(
          this.specMtlName.findIndex((x) => x === value.Name),
          1
        );
      }
      this.addForm.SpecMtlID = this.specMtlID.toString();
      this.addForm.SpecMtlName = this.specMtlName.toString();
    },
    selectStation(id) {
      this.addForm.StationLineID = id;
      this.addForm.StationLineName = this.stationLine.filter(
        (e) => e.Id == id
      )[0].Name;
    },
  },
  mounted() {
    /*获取出货单基础档案*/
    /*获取出货单基础档案*/
    this.getProdOutMaster();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    this.getBaseData();
    this.getSysStationLineList(this.orgList[0].Id);
  },
};
</script>

<style lang="less" scoped>
.input-select {
  width: 300px;
}
.hr-select {
  width: 100px;
}

.table-value {
  color: #23ade5;
  margin-right: 20px;
}
</style>
